import { render, staticRenderFns } from "./Envelop.vue?vue&type=template&id=cb41c62c&scoped=true&"
import script from "./Envelop.vue?vue&type=script&lang=js&"
export * from "./Envelop.vue?vue&type=script&lang=js&"
import style0 from "./Envelop.vue?vue&type=style&index=0&id=cb41c62c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb41c62c",
  null
  
)

component.options.__file = "Envelop.vue"
export default component.exports